(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("LoadMore");

  Components.create('LoadMore', {

    Selectors: {
      Container: '.js-container',
      TotalPages: '.js-total-pages',
      GetMore: '.js-load-more',
      Prizes: '.card-prize',
      Loader: '.js-loader',
      Filter: '.prize-reservation-filter',
      RemoveFilter: '.js-remove-filters',
      RangeFilter: 'select[name=points-range] option',
      CategoryFilter: 'select[name=prize-category] option',
      TypeFilter: 'select[name=prize-type] option'
    },
    page: 1,
    maxPage: 9,

    loadData: function(page, url, append) {
      this.$loader.addClass('in fade-in');

      const ajaxData = {
        params: {
          pointsRange: this.$pointsRange.filter(':selected').val(),
          prizeCategory: this.$prizeCategory.filter(':selected').val(),
          prizeType: this.$prizeType.filter(':selected').val(),
          page: page,
          bare: true
        }
      };

      axios.get(url, ajaxData)
        .then((response) => {
          this.$loader.removeClass('in fade-in');
          append ? this.$container.append(response.data) : this.$container.html(response.data);
          setTimeout(() => { this.pageSize();}, 100);
        })
        .catch(function (error) {
          logger.d("Couldn't get reservable prizes data: ", error);
        });
    },

    pageSize: function() {
      let totalPage = parseInt($(this.Selectors.TotalPages).data('totalpage'));
      let prizesNum = parseInt(this.$container.find(this.Selectors.Prizes).length);
      let nextPage = (prizesNum / this.maxPage) + 1;

      (nextPage  > totalPage) ? this.$getMore.addClass('hide') : this.$getMore.removeClass('hide');
    },

    enableGetMore: function() {
      this.$getMore.on('click', (e)=> {
        e.preventDefault();
        this.page++;
        this.loadData(this.page, this.url, true)

      });
    },

    enableFiltering: function() {
      this.$filter.on('change', (e) => {
        this.$removeFilters.removeClass('hide');
        this.page = 1;
        this.loadData(this.page, this.url, false);
      });
    },

    removeFilters: function() {
      $('option[data-select2-id]').prop('selected', false).trigger("change");
      this.$removeFilters.addClass('hide');
    },

    init: function() {
      this.$getMore = $(this.Selectors.GetMore);
      this.url = this.$getMore.data('url');
      this.$loader = $(this.Selectors.Loader);
      this.$container =  $(this.Selectors.Container);
      this.$filter = $(this.Selectors.Filter);
      this.$pointsRange = $(this.Selectors.RangeFilter);
      this.$prizeCategory = $(this.Selectors.CategoryFilter);
      this.$prizeType = $(this.Selectors.TypeFilter);
      this.$removeFilters = $(this.Selectors.RemoveFilter);
      this.enableGetMore();
      this.enableFiltering();


      this.$removeFilters.on('click', (e)=> {
        this.removeFilters();
      });
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);